// Pixel delivery budgets; component CSS continues to determine visual dimensions.
export const IMAGE_PRESETS = Object.freeze({
  'product-card': { widths: [320, 400], sizes: '(max-width: 767px) 50vw, (max-width: 991px) 33vw, 25vw' },
  'product-thumb': { widths: [96, 160], sizes: '96px' },
  'product-medium': { widths: [400, 640, 800], sizes: '(max-width: 767px) 100vw, 50vw' },
  'product-detail': { widths: [400, 800, 1200], sizes: '(max-width: 767px) 100vw, 50vw' },
  'product-zoom': { widths: [1200, 1800], sizes: '100vw' },
  'avatar-tiny': { widths: [96], sizes: '48px' },
  avatar: { widths: [96, 160, 256, 400], sizes: '160px' },
  category: { widths: [160, 256, 400], sizes: '(max-width: 767px) 50vw, 256px' },
  content: { widths: [320, 640, 960, 1280], sizes: '(max-width: 767px) 100vw, 75vw' },
  banner: { widths: [480, 768, 1280, 1600, 1920], sizes: '100vw' },
});
